'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var lurkerSend = function lurkerSend(payload) {
  /* eslint-disable */
  try {
    if (window.Lurker) {
      window.Lurker.send(payload);
    } else {
      console.log('DEBUG - ', payload);
    }
  } catch (error) {
    console.error('Error on send Lurker event: ' + error);
  }
  /* eslint-enable */
};

exports.default = lurkerSend;